import React from 'react';

import { useGirlBackgroundImage } from '../../hooks/useGirlBackgroundImage';

import OneNightStandBase from './OneNightStandBase';

const OneNightStandVariant: React.FC = () => {
  const backgroundImage = useGirlBackgroundImage();

  return <OneNightStandBase backgroundImage={backgroundImage} />;
};

export default OneNightStandVariant;
